import { RouterProvider } from "react-router-dom"

import Error from "./components/shared/ErrorModal/Error"
import HelpAIButton from "./components/HelpAI"
import AIChat from "./components/AIChat"
import { AccessControl } from "./components/accessControl"
import { appRouter } from "./Routes"
import { useEffect } from "react"
import {
  getPropsByEquipmentType,
  getPropertiesAndSymbols,
  listAnomaliesRules
} from "src/pages/fault-detection/graphql"
import { groupByKey } from "src/utils/CommonMethods"
import { API } from "src/shared/lib/amplify"
import { useDispatch } from "react-redux"
import {
  setAnomalyEquipmentTypes,
  setAnomalyUoMUnits,
  setAnomalyRulesList
} from "src/redux/slicers/buildingSummarySlice"
import { fetchAllList } from "src/stack/Queries/fetchAll"
import config from "./aws-exports"

const App = () => {
  const dispatch = useDispatch()

  const loadAnomalyRules = async () => {
    try {
      dispatch(setAnomalyRulesList({ type: "Loading" }))
      const data: any = await fetchAllList({
        query: listAnomaliesRules,
        path: "data.listAnomalyDetectionRules"
      })
      const totalItems = data?.list || []
      if (totalItems?.length > 0) {
        dispatch(setAnomalyRulesList({ type: "Success", data: totalItems }))
      }
    } catch (e) {}
  }

  const loadUOMSymbols = async () => {
    try {
      const uomSymbols = []
      dispatch(setAnomalyUoMUnits({ type: "Loading" }))
      const { data }: any = await API.graphql({
        query: getPropertiesAndSymbols
      })

      const totalItems = data?.configByTypeAndSubtype?.items || []
      if (totalItems?.length > 0) {
        totalItems?.forEach((item) => {
          const value = JSON.parse(item.value)
          if (value.Symbol) {
            uomSymbols.push({
              subType: item?.subType?.toLowerCase() || "",
              ...value
            })
          }
        })
        dispatch(setAnomalyUoMUnits({ type: "Success", data: uomSymbols }))
      }
    } catch (e) {}
  }

  const loadEquipmentTypesForAnomaly = async () => {
    try {
      dispatch(setAnomalyEquipmentTypes({ type: "Loading" }))
      const data: any = await fetchAllList({
        query: getPropsByEquipmentType,
        variables: {
          filter: {
            isRDR: { eq: 1 },
            sourceEquipmentType: { eq: "NA" },
            sourceFamilyType: { eq: "NA" }
          }
        },
        path: "data.searchPropertyMetadata"
      })

      const totalProperties = data?.list || []
      if (totalProperties?.length > 0) {
        const groupedByEquipmentType = groupByKey(
          totalProperties,
          "equipmentType"
        )
        dispatch(
          setAnomalyEquipmentTypes({
            type: "Success",
            data: groupedByEquipmentType
          })
        )
      }
    } catch (e) {}
  }

  useEffect(() => {
    loadEquipmentTypesForAnomaly()
    loadUOMSymbols()
    loadAnomalyRules()
  }, [])

  useEffect(() => {
    // Update the document title based on the region
    if (config.aws_project_region === "eu-central-1")
      document.title = `Command Center EMEA`
  }, [])

  return (
    <>
      <RouterProvider router={appRouter} />
      <Error />
      <AccessControl id={["cc.poc"]}>
        <HelpAIButton theme="dark" />
      </AccessControl>
      <AccessControl id={["cc.ai-access"]}>
        <AIChat />
      </AccessControl>
    </>
  )
}
export default App
